import { PAGE_NAME, UNREAD_MESSAGE } from './key'
import { actionCreator, chatActionCreator } from '../action-created'

export const pushPageName = (payload) => actionCreator(PAGE_NAME, payload)
export const setUnreadMessagesCount = payload => chatActionCreator(UNREAD_MESSAGE, payload)
